import { render } from "./EditUserPage.vue?vue&type=template&id=ecf9a7aa"
import script from "./EditUserPage.vue?vue&type=script&lang=js"
export * from "./EditUserPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__